
import VueRouter from 'vue-router';
const routes =[
    {
        path:'/',
        name:'login',
        component:()=>import('../components/Login')
    },
    {
        path: '/Register',
        name: 'register',
        component: () => import('../components/Register'),
    },
    {
        path:'/myIndex',
        name:'myIndex',
        component:()=>import('../components/myIndex'),
        //个人中心作为子路由，也就是首页的二级路由
        children:[
            {
                path:'/Home',
                name:'home',
                meta:{
                  title:'首页'
                },
                component:()=>import('../components/Home'),
            },
            /*{
                path:'/Admin',
                name:'admin',
                meta:{
                    title:'管理员管理'
                },
                component:()=>import('../components/admin/AdminManage.vue'),
            },
            {
                path:'/User',
                name:'user',
                meta:{
                    title:'用户管理'
                },
                component:()=>import('../components/user/UserManage.vue'),
            },*/
        ]
    }
]
export function resetRouter() {
    router.matcher = new VueRouter({
        mode:'history',
        routes: []
    }).matcher
}
const router = new VueRouter({
    mode:'history',
    routes
})
const VueRouterPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (to) {
    return VueRouterPush.call(this, to).catch(err => err)
}
export default router;